import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { useState } from "react";
import { supabase } from "../lib/supabase";

// Login con email+password (Supabase Auth). Tras autenticar, el JWT lleva
// app_metadata { organization_id, role } y el SessionProvider carga sucursales.
export const Route = createFileRoute("/login")({ component: Login });

function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setErr(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error) { setErr(error.message); return; }
    nav({ to: "/" });
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-grafito-900 p-4">
      <form onSubmit={onSubmit} className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-xl">
        <div className="mb-6 text-center text-2xl font-extrabold">🔧 FerreSaaS</div>
        {err && <div className="mb-4 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{err}</div>}
        <label className="mb-1 block text-sm font-medium">Correo</label>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          className="mb-4 w-full rounded-lg border px-3 py-2 outline-none focus:border-brand" />
        <label className="mb-1 block text-sm font-medium">Contraseña</label>
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          className="mb-6 w-full rounded-lg border px-3 py-2 outline-none focus:border-brand" />
        <button disabled={busy} className="btn btn-primary w-full py-2.5 disabled:opacity-50">
          {busy ? "Entrando…" : "Entrar"}
        </button>
        <p className="mt-4 text-center text-sm text-grafito-400">
          ¿Primera vez? <Link to="/registro" className="text-brand">Crea tu ferretería</Link>
        </p>
      </form>
    </div>
  );
}
